const FieldPaths = {
	EVENT_TIME: 'event.date',
	RECEIVED_TIME: 'metadata.receiveddate',
	TASK_STATUS: 'task.statusCode',
};

export default FieldPaths;
